<h1 mat-dialog-title>Zu-/ Abschläge</h1>
<mat-dialog-content class="content">
    <app-e-invoice-allowance-charge-view *ngFor="let charge of allowanceCharges" [charge]="charge" [currencyCode]="currencyCode"></app-e-invoice-allowance-charge-view>
</mat-dialog-content>
<mat-dialog-actions>
    <button app-button Color="cancel" Inverted mat-dialog-close="">Schließen</button>
</mat-dialog-actions>
